var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('invocations',{attrs:{"invocation-items":_vm.invocationItems,"loading":_vm.loading,"no-invocations-message":"There are no invocations to be shown."},on:{"reload-invocations":_vm.fetchRecentInvocations}})}
var staticRenderFns = []

export { render, staticRenderFns }